import { PATH, pageName } from './constants';
import HomePage from './components';
import renderPage from '../config/renderPage';
import { dataLakeMiddleware, gaPageViewMiddleware } from '../middleware/pageView';
import analytics from './analytics';
import reducers from './reducers';
import meta from './meta';

renderPage({
    initialState: window.__REDUX_STATE__,
    reducers,
    routes: [{
        path: PATH,
        component: HomePage,
    }],
    pageName,
    preGaCustomMiddleware: [
        gaPageViewMiddleware(analytics, window.location),
        dataLakeMiddleware(window.location, window.document, analytics),
    ],
    meta,
});
